<template>
  <div class="page-wrapper">
    <div class="container-fluid p-0">
      <!-- login page start-->
      <div class="authentication-main">
        <div class="row">
          <div class="col-md-12">
            <div class="auth-innerright">
              <div class="authentication-box">
                <div class="text-center">
                  <img alt id="infralogo" src="../assets/infralogo.png" />
                </div>
                <div class="card mt-4">
                  <div class="card-body">
                    <div class="text-center">
                      <h4>Passwort einrichten</h4>
                      <h6>Geben Sie Ihre E-Mail ein.</h6>
                    </div>
                    <form class="theme-form">
                      <div class="form-group">
                        <label class="col-form-label">E-Mail</label>
                        <input class="form-control" type="text" v-model="email" />
                      </div>
                      <div class="form-group form-row mb-0">
                        <div class="col-md-2">
                          <button class="btn btn-primary" @click.prevent="validate">Abschicken</button>
                        </div>
                      </div>
                      <div class="errors">
                        <transition name="fade">
                          <div v-if="!emailValid">Bitte geben Sie eine gültige E-Mail ein.</div>
                        </transition>
                        <transition name="fade">
                          <div v-if="resetError">Fehler, ist Ihre E-Mail Addresse korrekt?</div>
                        </transition>
                        <transition>
                          <div v-if="emailExists == false">Diese Email Adresse ist im System nicht hinterlegt.</div>
                        </transition>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- login page end-->
    </div>
  </div>
</template>

<script>
export default {
  name: "forgotPassword",
  data: function() {
    return {
      email: "",
      emailValid: true,
      resetError: false,
      emailExists: null,
    };
  },
  methods: {
    async validate() {
      const emailTest = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const valid = emailTest.test(this.email);

      if (!valid) {
        this.emailValid = false;
        setTimeout(() => {
          this.emailValid = true;
        }, 4000);
        return;
      }

      if (valid) {
        try {
          await this.$store.dispatch("auth/reqPwReset", this.email);
          this.$router.push("/");
        } catch (error) {
          console.log(error);
          this.resetError = true;
          setTimeout(() => {
            this.resetError = false;
          }, 4000);
        }
      }
    },
  },
};
</script>

<style></style>
